import { createContainer, createHook, createStore } from 'react-sweet-state';

import {
	PricingPeriod,
	FormattedPriceCalculationResponse,
	CurrencyISOCode,
	PriceFinderMessages,
} from '../constants';

import * as actions from './actions';

export type PriceFinderState = {
	unitCount: number;
	billingCycle: PricingPeriod;
	priceCalcs: FormattedPriceCalculationResponse[];
	currencyISOCode: CurrencyISOCode;
	messages: PriceFinderMessages;
};

export const initialState: PriceFinderState = {
	unitCount: 0,
	billingCycle: 'MONTHLY',
	priceCalcs: [],
	currencyISOCode: 'USD',
	messages: {
		// These messages always be overridden by the consumer on init
		unitCountInputText: {},
		unitCountInputTooltip: {},
		cardOverSignupLimit: {},
		cardEnterpriseMinimumCount: {},
		cardUnitCountTierRange: {},
		cardMonthlyPerUnitCount: {},
		cardFreeDescription: {},
	},
};

export const PriceFinderContainer = createContainer<PriceFinderState>();

const store = createStore({
	containedBy: PriceFinderContainer,
	name: 'price-finder',
	initialState,
	actions,
	handlers: {
		onInit:
			() =>
			({ setState }, state: PriceFinderState) => {
				setState({ ...state });
			},
	},
});

export const usePriceFinderStore = createHook(store);
